import './style';
import 'typeface-roboto';

import App from './components/app';

export default App;
